// FILECONTENT_START src/common/components/Breadcrumbs/index.ts
import Breadcrumbs from "./Breadcrumbs";
export default Breadcrumbs;

// FILECONTENT_END src/common/components/Breadcrumbs/index.ts